import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import './mixins/global.mixin'
import './mixins/help-page'
import '@/plugins/highcharts'
import '@/plugins/router-sync'
import '@/plugins/scroll-to'
import '@/plugins/rollbar'
import '@/plugins/html-to-paper'
import '@/plugins/ag-grid'
import './plugins/quasar'
import '@/plugins/styles'
import '@/plugins/vuelidate'
import '@/plugins/google-analytics'
import '@/plugins/global-components'
import { bootActions } from '@/utils/boot-actions'

Vue.config.productionTip = false

bootActions(store)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (window.Cypress) {
  window.store = store
}
